
import { makeAutoObservable } from 'mobx'
import { injectable, inject, decorate } from 'inversify'
import { DisplayThread, ThreadStore } from '@evertel/stores'
import { Api } from '@evertel/api'

class CreateThreadController {

    constructor(
        private api: Api,
        private threadStore: ThreadStore
    ) {
        makeAutoObservable(this)
    }


    createThread = async (userId: number|number[]) => {
        const userIds = Array.isArray(userId) ? userId : [userId]

        const thread = await this.api.Routes.Thread.postStart(userIds) as DisplayThread

        thread.isBotThread = thread.meta?.isBotThread
        thread.userIds = userIds

        this.threadStore.update(thread)

        return thread
    }
}

decorate(injectable(), CreateThreadController)
decorate(inject(Api), CreateThreadController, 0)
decorate(inject(ThreadStore), CreateThreadController, 1)

export { CreateThreadController }
